import { Component, inject, input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BannerCardComponent } from '@shared/components/banner-card/banner-card.component';
import { IBreadcrumb } from '@shared/components/breadcrumb/breadcrumb.component';
import { ICreateEntityButtonConfiguration } from '@shared/components/create-entity-button/create-entity-button.interface';
import { CustomersKpiCardsComponent } from './customers-kpi-cards/customers-kpi-cards.component';

@Component({
  imports: [BannerCardComponent, TranslateModule, CustomersKpiCardsComponent],
  selector: 'app-customers-banner',
  templateUrl: './customers-banner.component.html',
})
export class CustomersBannerComponent {
  public readonly addButtonConfiguration = input<ICreateEntityButtonConfiguration | null>(null);

  private readonly translate = inject(TranslateService);

  public readonly breadcrumbs: IBreadcrumb[] = [
    {
      label: this.translate.instant('pages.customers.banner.title'),
      link: '/dashboard',
    },
  ];
}
